"use client";

import React, { useState, useMemo } from "react";
import CommonLayout from "./CommonLayout";
import { track } from "@/lib/tracking";

const getAccordionData = (cityName?: string) => [
  {
    _id: "accordion_1",
    title: cityName
      ? `What documents do I need to rent a bike in ${cityName}?`
      : "What are the documents required for bike rental?",
    description: (
      <p>
        You must submit one original ID (Aadhar Card, Voter ID, Passport or any other Govt. ID) and a soft/ hard copy of a valid driving license. International customers must submit a copy of their passport and a valid driving license.
      </p>
    ),
  },
  {
    _id: "accordion_2",
    title: cityName
      ? `Is there a security deposit for bike rental in ${cityName}?`
      : "Is there any deposit that I have to pay?",
    description: (
      <p>
        Yes, there is a refundable security deposit which will be collected at the vendor location or by the delivery executive in case on home delivery.
      </p>
    ),
  },
  {
    _id: "accordion_3",
    title: cityName
      ? `What if I have a breakdown while riding in ${cityName}?`
      : "What if I have an accident or breakdown?",
    description: (
      <p>
        In case of an accident or breakdown, contact our support team immediately at 8123727036. We provide roadside assistance and will guide you through the process.
      </p>
    ),
  },
  {
    _id: "accordion_4",
    title: "Is petrol included in the rental?",
    description: (
      <p>
       No, petrol is not included in the rental charges.
      </p>
    ),
  },
  ...(cityName ? [{
    _id: "accordion_5",
    title: `Do you offer doorstep delivery in ${cityName}?`,
    description: (
      <p>
        Yes! RideNGo offers doorstep delivery and pickup across {cityName}. You can get your rented bike or scooter delivered right to your location.
      </p>
    ),
  }] : []),
];

interface accordion {
  _id: string;
  title: string;
  description: React.ReactNode;
}
type AccordionShowState = {
  [key: string]: boolean;
};

interface FAQProps {
  cityName?: string;
}

const FAQ: React.FC<FAQProps> = ({ cityName }) => {
  const accordionData = useMemo(() => getAccordionData(cityName), [cityName]);

  const [accordionShow, setAccordionShow] = useState<AccordionShowState>({
    accordion_1: false,
    accordion_2: false,
    accordion_3: false,
    accordion_4: false,
    accordion_5: false,
  });
  const toggleAccordion = (accordionKey: string) => {
    setAccordionShow((prevState: AccordionShowState) => {
      const updatedAccordionShow = { ...prevState };
      Object.keys(prevState).forEach((key) => {
        updatedAccordionShow[key] =
          key === accordionKey ? !prevState[key] : false;
      });

      if (!prevState[accordionKey]) {
        const faqItem = accordionData.find(item => item._id === accordionKey);
        if (faqItem) {
          track('faq_opened', {
            question: faqItem.title,
            source_page: typeof document !== 'undefined' ? document.title : '',
          });
        }
      }

      return updatedAccordionShow;
    });
  };

  return (
    <>
      <CommonLayout className="py-[50px] md:py-[70px]">
        <div className="flex justify-between items-center flex-wrap">
          <div className="w-full md:w-1/2 flex ">
            <div className="w-[420px]">
              <h2 className="text-[20px] md:text-[32px] font-medium text-black">
                Got a Question?
              </h2>
              <h3 className="text-[20px] md:text-[32px] font-medium !text-[#F05A24] mb-4" >We got you.</h3>
              <h4 className="text-[12px] md:text-[16px] font-medium text-gray-700">
                {cityName
                  ? `Get answers to commonly asked questions about bike rentals in ${cityName}.`
                  : 'Get answers to commonly asked questions about RidenGo rental services.'}
              </h4>
            </div>
          </div>
          <div className="w-full md:w-1/2">
            <div >
              {accordionData.map((item: accordion) => {
                return (
                  <div key={item._id} className="w-full border-b border-gray-200 py-4">
                    <button
                      type="button"
                      className="flex items-center justify-between w-full "
                      onClick={() => toggleAccordion(item._id)}
                    >
                      <p className="text-[14px] md:text-[16px] font-medium text-black text-left">{item.title}</p>+
                    </button>

                    {accordionShow[item._id] && (
                      <div className="text-[14px] font-normal text-gray-700 mt-2">{item.description}</div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </CommonLayout>
    </>
  );
};

export default FAQ;
